import { useAccount } from '@src/contexts';
import useMedia from '@src/hooks/utils/useMedia';
import { getBusinessDocumentationSchema } from '../utils';
import { BusinessDocumentationFormData } from '../components/businessDocumentationStep';
import { useMemo } from 'react';
import { v4 } from 'uuid';
import ClientApi from '@src/types/client';
import { checkNAValues } from '@src/utils/checkNAValues';

interface IUseBusinessDocumentationFormOptions {
  businessInformationDetails:
    | ClientApi.Onboarding.GetBusinessInformationDetails.Response['data']
    | undefined;
  agreementValue?: boolean;
}

const useBusinessDocumentationForm = ({
  businessInformationDetails,
  agreementValue = false
}: IUseBusinessDocumentationFormOptions) => {
  const { user } = useAccount();
  const { isMobile } = useMedia();

  const validationSchema = getBusinessDocumentationSchema();

  const initialValues: BusinessDocumentationFormData = useMemo(() => {
    const businessDocument = businessInformationDetails?.businessDocument;

    return {
      certificateOfIncorporation: checkNAValues(
        businessDocument?.certificateOfIncorporation || null
      ),
      amlComplianceDocument: checkNAValues(businessDocument?.amlDocumentation || null),
      agentOnboardingKybForm: checkNAValues(businessDocument?.agentOnboardingKYBForm || null),
      otherComplianceDocs:
        businessDocument?.otherComplianceDocuments?.map((doc) => ({
          id: doc?.id || v4(),
          document: doc?.otherDocumentationType || null,
          documentName: doc.title || '',
          show: true
        })) || [],
      agreement: agreementValue,
      einCertificate: checkNAValues(businessDocument?.einCertificate || null),
      irsCertificate: checkNAValues(businessDocument?.irsCertificate || null),
      certificateOfGoodStanding: checkNAValues(businessDocument?.certificateOfGoodStanding || null),
      businessDba: checkNAValues(businessDocument?.businessDBA || null)
    };
  }, [businessInformationDetails, agreementValue]);

  return { validationSchema, initialValues, isMobile, user };
};

export default useBusinessDocumentationForm;
